import React from "react";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { useEmployeeProfileFormPage } from "@/modules/administration/features/EmployeeDirectoryManagement/hooks/useEmployeeProfileFormPage";
import EmployeeProfileForm from "@/modules/administration/features/EmployeeDirectoryManagement/components/Profile/EmployeeProfileForm/EmployeeProfileForm";

const CreateEmployeeProfilePage: React.FC = () => {
  const pageState = useEmployeeProfileFormPage({ mode: "create" });

  return (
    <MainPageWrapper title="Create Employee Profile">
      <EmployeeProfileForm pageState={pageState} />
    </MainPageWrapper>
  );
};

export default CreateEmployeeProfilePage;
